import { useMemo } from 'react';

import { Overrides, ComponentName, OverridesResult, OverridesComponent } from './types';
import getComponents from './getComponents';

function useOverrides<T extends Overrides>(
    defaultComponents: {
        [P in ComponentName<T>]: OverridesComponent;
    },
    overrides: Partial<T> = {},
): OverridesResult<T> {
    const components = useMemo(() => getComponents(defaultComponents, overrides), [
        defaultComponents,
        overrides,
    ]);

    return components;
}

export default useOverrides;
